import PricingContent from "./PricingContent";

const PricingSection = () => {
  return (
    <section id="pricing" className="py-24 bg-background">
      <div className="container mx-auto px-4">
        <PricingContent />
      </div>
    </section>
  );
};

export default PricingSection;
